import React, { useEffect } from 'react';
import { FaExclamation as ExclamationIcon } from 'react-icons/fa';
import { Link, LinkProps } from 'react-router-dom';

import { debouncedRebuildReactTooltip } from '../shared/debouncedRebuildReactTooltip';
import { menuTooltipContainerId } from './constants';


type MenuLinkProps = LinkProps & (
  {disabled?: false, disabledReason?: string}
 | {disabled: true, disabledReason: string}
  )

export const MenuLink: React.FC<MenuLinkProps> = ({ disabled, disabledReason, ...linkProps }: MenuLinkProps) => {
  useEffect(() => {
    debouncedRebuildReactTooltip();
  }, [disabled, disabledReason]);

  if (disabled) {
    return (
      <div>
        <ExclamationIcon className="text-warning" data-tip={disabledReason} data-for={menuTooltipContainerId}/>
        <span className="text-muted menu-link-text">{ linkProps.children }</span>
      </div>
    );
  }

  return <Link {...linkProps}/>;
};
